let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3upTg")).then(() => parcelRequire('8RJMJ'));